import { createApi } from "@reduxjs/toolkit/query/react";
import axiosBaseQuery from "../../utils/axiosBaseQuery";
import {
  ADD_PRODUCT_SETTINGS,
  GET_PRODUCT_SETTINGS,
  UPDATE_PRODUCT_SETTINGS,
} from "../../config/constants";

const deliveryInformationService = createApi({
  reducerPath: "deliveryInformationService",
  baseQuery: axiosBaseQuery({ baseUrl: "" }),
  tagTypes: ["DeliveryInformation"],
  endpoints: (builder) => ({
    getDeliveryInformation: builder.query({
      query: (body) => ({
        url: GET_PRODUCT_SETTINGS,
        method: "GET",
        data: body,
      }),
      providesTags: ["DeliveryInformation"],
    }),
    updateDeliveryInformation: builder.mutation({
      query: ({ updatedData }) => ({
        url: UPDATE_PRODUCT_SETTINGS,
        method: "PUT",
        data: updatedData,
      }),
      invalidatesTags: ["DeliveryInformation"],
    }),
    addDeliveryInformation: builder.mutation({
      query: (newData) => ({
        url: ADD_PRODUCT_SETTINGS,
        method: "POST",
        data: newData,
      }),
      invalidatesTags: ["DeliveryInformation"],
    }),
  }),
});

export const {
  useGetDeliveryInformationQuery,
  useUpdateDeliveryInformationMutation,
  useAddDeliveryInformationMutation,
} = deliveryInformationService;

export default deliveryInformationService;
